import { useEffect, useRef, useState } from 'react'
import { Button } from './Button'
import { copyText } from '../utils/clipboard'

type CopyButtonProps = {
  value: string
  label?: string
  copiedLabel?: string
  className?: string
  size?: 'sm' | 'md'
  disabled?: boolean
  onCopyResult?: (ok: boolean) => void
}

export function CopyButton({
  value,
  label = 'コピー',
  copiedLabel = 'コピー済み',
  className,
  size = 'sm',
  disabled = false,
  onCopyResult,
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<number | null>(null)

  useEffect(() => {
    setCopied(false)
  }, [value])

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const handleCopy = async () => {
    const ok = await copyText(value)
    onCopyResult?.(ok)
    if (!ok) return

    setCopied(true)
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = window.setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Button
      type="button"
      variant="secondary"
      size={size}
      className={className}
      disabled={disabled || !value}
      onClick={handleCopy}
    >
      {copied ? copiedLabel : label}
    </Button>
  )
}
